import scss from './tooltipMarkup.module.scss';

const createTooltipMarkup = ({ tooltipModel, averages }) => {
  if (!tooltipModel) {
    return '';
  }

  const dataPoints = tooltipModel.dataPoints;
  const title = tooltipModel.title[0];
  const foundAverage = averages.find((average) => average.name === title);

  const calculations = dataPoints.map((dataPoint) => ({
    label: dataPoint.dataset.label,
    value: dataPoint.raw || 0,
    color: dataPoint.dataset.backgroundColor,
  }));

  return `
    <div class='${scss.outerBox}'>
      <div class='${scss.title}'>
       ${title}
      </div>
      <div class='${scss.infoBlock}'>
         ${calculations.map(createRecord).join('\n')} 
         ${createRecord({ label: 'AVG', value: foundAverage?.value, color: '#fdbf47' })}
      </div>
    </div>
  `;
};

export default createTooltipMarkup;

const createRecord = ({ label, value, color }) => {
  return `
    <div class='${scss.record}'>
     ${color ? `<div class="${scss.marker}" style="background-color: ${color}"></div>` : ''}
      <span class='${scss.label}'>${label}:</span>
      <span class='${scss.value}'>${value}%</span>
    </div>
  `;
};
